import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchBranchesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.branches = arrayToObjectCovert(action.payload.data);
  state.branchesOrder = action.payload.data.map(branch => branch.id);
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.totalBranches = action.payload.total_branch_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleBranchesByPartnerStaffIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.branchesByPartnerStaffId = action.payload.data;
}

const handleFetchMappingBranchesFulfilled = (state, action) => {
  state.status = 'succeeded';
  if (Array.isArray(action.payload)) {
     state.mappingBranches = action.payload;
  } else {
     state.mappingBranches = action.payload.data;
  }
};

const handleAddBranchFulfilled = (state, action) => {
  state.status = 'succeeded';
  const branchId = action.payload.data.id;
  if (!state.branches[branchId]) {
    state.branches[branchId] = [];
  }
  state.branches[branchId].push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchBranchByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentBranch = action.payload.data;
};

const handleUpdateBranchFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.branches[action.payload.data.id] = action.payload.data;
  state.currentBranch = action.payload.data;
  state.message = action.payload.message;
};

const handleFetchBranchesByAgencyIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentAgencyBranches = action.payload.data;
  state.message = action.payload.message;
};

const handleFetchActiveBranchesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentActiveBranches = action.payload.data;
  state.message = action.payload.message;
};


export {
  handleFetchBranchesFulfilled,
  handleFetchMappingBranchesFulfilled,
  handleAddBranchFulfilled,
  handleFetchBranchByIdFulfilled,
  handleUpdateBranchFulfilled,
  handleFetchBranchesByAgencyIdFulfilled,
  handleFetchActiveBranchesFulfilled,
  handleBranchesByPartnerStaffIdFulfilled,
};
